/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAirtableIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-airtable" */ './utils').then((m) => m.AirtableIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/airtable/icon' },
);

const LazyAirtableSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-airtable-search-result" */ './utils').then(
			(m) => m.AirtableSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AirtableIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAirtableIconComponent />
	</Suspense>
);

export const AirtableSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAirtableSearchResultIconComponent />
	</Suspense>
);
